const slice = 'cart';

export const ADD_TO_CART = `${slice}/addItem`;
export const REMOVE_FROM_CART = `${slice}/removeItem`;
export const INCREASE_CART_QTY = `${slice}/increaseQuantity`;
export const DECREASE_CART_QTY = `${slice}/decreaseQuantity`;